import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Row, Col, Typography } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { useUser } from '../contexts/UserContext';
import { PageHeader } from './common';

const { Title, Text } = Typography;

const Dashboard = () => {
  const { user } = useUser();
  const navigate = useNavigate();

  const modules = [
    {
      name: 'TrustGrid',
      description: 'Security compliance monitoring and control framework',
      path: '/trustgrid',
      icon: '🔒',
      color: '#4CAF50'
    },
    {
      name: 'AI/ML',
      description: 'Test case generation and AI/ML model compliance',
      path: '/ai-ml',
      icon: '🤖',
      color: '#2196F3'
    },
    {
      name: 'Quality & Compliance',
      description: 'Quality management and compliance tracking',
      path: '/quality-compliance',
      icon: '✓',
      color: '#FF9800'
    }
  ];

  const handleModuleClick = (path) => {
    navigate(path);
  };

  return (
    <>
      <PageHeader
        title="Dashboard"
        breadcrumbs={[
          { label: 'Dashboard' }
        ]}
        extra={
          <div>
            <Title level={3} style={{ margin: 0, marginBottom: '8px', fontWeight: 600, color: '#17052B' }}>
              Welcome back, {user?.first_name || 'User'}!
            </Title>
            <Text type="secondary" style={{ fontSize: '15px' }}>
              Select a module to get started
            </Text>
          </div>
        }
      />

      <Row gutter={[20, 20]} style={{ marginBottom: '32px' }}>
        {modules.map((module, index) => (
          <Col xs={24} sm={24} md={12} lg={12} xl={6} key={index}>
            <Card
              hoverable
              onClick={() => handleModuleClick(module.path)}
              style={{
                borderLeft: `4px solid ${module.color}`,
                cursor: 'pointer',
                height: '100%',
              }}
              bodyStyle={{ padding: '20px' }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <div
                  style={{
                    width: '50px',
                    height: '50px',
                    borderRadius: '8px',
                    backgroundColor: `${module.color}20`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '24px',
                    flexShrink: 0,
                  }}
                >
                  <span style={{ color: module.color }}>{module.icon}</span>
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <Title level={4} style={{ margin: 0, marginBottom: '4px', fontSize: '16px', color: '#17052B' }}>
                    {module.name}
                  </Title>
                  <Text type="secondary" style={{ fontSize: '13px', display: 'block' }}>
                    {module.description}
                  </Text>
                </div>
                <RightOutlined style={{ color: '#999', fontSize: '16px', flexShrink: 0 }} />
              </div>
            </Card>
          </Col>
        ))}
      </Row>

      <Card
        title="Quick Stats"
        style={{ marginTop: '32px' }}
      >
        <Text type="secondary">
          System statistics and activity summaries will appear here
        </Text>
      </Card>
    </>
  );
};

export default Dashboard;
